export default function(h, row, index) {
    if (row.comment_text.length < 200)
        return row.comment_text
    let d = row.comment_text.substring(0,194);
    return <span>{d}......</span>
}
